// src/utils/bulkColumnMapping.js
/**
 * Resolves a canonical Excel column's value from a parsed row, honoring any
 * user-configured column-name aliases (see ColumnMappingModal). Falls back to
 * the canonical header name when no mapping is configured.
 */
export const resolveColumn = (row, canonicalKey, columnMappings) => {
  const mapped = columnMappings?.[canonicalKey];
  if (Array.isArray(mapped)) {
    for (const k of mapped) {
      if (k && k.trim() && row[k] !== undefined) return row[k];
    }
  } else if (mapped && mapped.trim && mapped.trim() && row[mapped] !== undefined) {
    // backward compat: old single-string format
    return row[mapped];
  }
  return row[canonicalKey];
};
